import React from 'react';
import { ArticleCard, Pagination, Flex, Box, Tag } from '@cowsquare/design';
import { navigate } from '@reach/router';
import { Link } from 'gatsby';
import styled from 'styled-components';
import * as R from 'ramda';
import defaultAuthorAvatar from '../asset/defaultAuthorAvatar.png';
import defaultCover from '../asset/defaultCover.jpg';
import { getHTMLString } from '../utils/getHTMLString';

const ListBox = styled(Box)`
  & > :last-child {
    margin-bottom: 0;
  }
`;

export const getItemProps = ({ item, uri }) => ({
  height: ['389px', '220px'],
  title: R.propOr('', 'name', item),
  description: R.pipe(R.pathOr('', ['content']), getHTMLString)(item),
  variant: ['vertical', 'horizontal'],
  coverUrl: R.pathOr(defaultCover, ['cover_file', 'link'], item),
  author: {
    name: R.pathOr('', ['author', 'name'], item),
    imgUrl: R.pathOr(defaultAuthorAvatar, ['author', 'real_avatar'], item),
  },
  date: R.propOr('', 'created_at', item),
  tags: R.pipe(
    R.propOr([], 'tags'),
    R.map(R.path(['tag', 'name'])),
    R.map(tag => (
      <Tag
        key={tag}
        onClick={event => {
          event.preventDefault();
          event.stopPropagation();
          navigate(`${uri}?tag=${tag}`);
        }}
      >
        {tag}
      </Tag>
    ))
  )(item),
});

export const ArticleCardList = ({
  uri,
  page,
  pageSize = 20,
  onPageChange,
  list = [],
  total = 0,
  options = () => {},
}) => {
  const totalPages = Math.ceil(total / pageSize);

  return (
    <>
      <ListBox pb={totalPages > 1 ? 8 : 0}>
        {R.map(
          item => (
            <Box key={item.id} mb={5}>
              <ArticleCard
                as={Link}
                to={`${uri}/${R.propOr('', 'id', item)}`}
                {...getItemProps({ item, uri })}
                {...options(item)}
              />
            </Box>
          ),
          list
        )}
      </ListBox>
      {total > pageSize && (
        <Flex justifyContent="center">
          <Pagination current={page} total={total} pageSize={pageSize} onChange={onPageChange} />
        </Flex>
      )}
    </>
  );
};
